<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <safety-manager-manage-div
      :popupVisible="popupVisible"
      @popupClose="popupClose"
      title="안전책임자 평가 양식 관리"
    />
    <v-sheet class="contents-container">
      <i-card-vertical
        headerTitle="안전책임자 관리"
        device="web"
        :IsUseInnerAddition="true"
        :IsUseEditorBox="true"
      >
        <template v-slot:EditorBox>
          <date-bar
            :firstDisplayDate="startDate"
            :dateOnly="true"
            label="조회년도"
            year
            full-width
            no-title
            @getDate="handleDateChange"
          ></date-bar>
        </template>
        <template v-slot:innerAddition>
          <v-btn
            color="primary"
            large
            elevation="0"
            outlined
            class="rounded ml-2"
            @click="btnPopup"
          >안전책임자 평가 양식 관리</v-btn>
        </template>
        <template v-slot:body>
          <DxDataGrid
            id="datagridRef"
            width="100%"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="datagrid"
            :show-borders="true"
            :show-row-lines="true"
            :column-auto-width="true"
            :allow-column-resizing="true"
            :allow-column-reordering="true"
            :focused-row-enabled="true"
            key-expr="id"
          >
            <DxEditing mode="batch" :allow-updating="false" />
            <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />
            <DxColumn
              data-field="save"
              data-type="string"
              width="120px"
              alignment="center"
              caption
              :allow-editing="false"
              cell-template="actionTemplete"
            ></DxColumn>
            <template #actionTemplete="{ data: cellInfo }">
              <div>
                <v-btn
                  color="primary"
                  elevation="0"
                  small
                  @click="btnDetail(cellInfo)"
                  class="grid-btn rounded"
                >상세보기</v-btn>
              </div>
            </template>

            <DxColumn
              data-field="clntId"
              data-type="string"
              alignment="left"
              caption="고객번호"
              :visible="false"
            />
            <!--DxColumn data-field="compId" data-type="string" alignment="left" caption="사업장">
              <DxLookup :data-source="compList" value-expr="compId" display-expr="compNm" />
            </DxColumn-->
            <DxColumn
              data-field="docNo"
              data-type="string"
              alignment="left"
              caption="문서번호"
              :visible="false"
            />

            <DxColumn
              css-class="devest-grid-header-require"
              data-field="manageNm"
              data-type="string"
              alignment="left"
              caption="안전책임자 관리명"
            />
            <DxColumn
              data-field="orgnOrder"
              data-type="string"
              alignment="center"
              caption="조직구성 차수"
            />
            <DxColumn data-field="orgnOrderNm" data-type="string" alignment="left" caption="조직구성명" />

            <DxColumn data-field="userNm" data-type="string" alignment="center" caption="작성자" />

            <DxColumn
              data-field="writeDt"
              data-type="date"
              format="yyyy.MM.dd"
              alignment="center"
              caption="작성일"
            />
          </DxDataGrid>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer
            v-model="procedureShow"
            width="75%"
            absolute
            right
            temporary
            class="feedback-area"
          >
            <ProcedureComponent :type="true" :subTitle="'절차서'" :pageTitle="'LeaderShip'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          class="d-md-flex"
          :useBtnList="buttonUseList"
          @btnAdd="btnAdd()"
          @btnSearch="btnSearch(true)"
          @btnDelete="btnDelete()"
        ></i-card-right>
        <!-- <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>-->
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import dateBar from '@/components/common/dateBar.vue'
import SafetyManagerManageDiv from './SafetyManagerManageDiv.vue'
import { getSafetyManagerManageMaster, getOrgnOrder, deleteSafetyManagerManage } from '@/api/evaluationImprovement/safetyManagerManage.js'
import { getCurrentDate, getPreMonth, getYearFormat } from '@/utils/common.js'
import { getCompanyList } from '@/api/baseManage/compManage'
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    dateBar,
    SafetyManagerManageDiv,
    // 절차서 컴포넌트
    ProcedureComponent
  },
  data() {
    return {
      dxDataGridRef: 'datagridRef',
      datagrid: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnDelete' //삭제
      ],
      startDate: getPreMonth(0),
      searchStartDate: getYearFormat(getPreMonth(0)),
      compList: [],
      initCompId: '',
      popupVisible: false,
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false // 절차서 보이기
    }
  },
  computed: {},
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
  },
  beforeMount() {
    Promise.all([getCompanyList({ clntId: this.getClntId() })]).then(response => {
      let failedResponse = response.find(element => !element.success)
      if (failedResponse == null) {
        this.compList = response[0].list
      } else {
        this.$vToastify.error({ body: failedResponse.msg })
        this.vToastify(failedResponse.msg, 'error')
      }
    })
  },
  mounted() {
    // this.btnSearch(true)
  },
  activated() {
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.$store.state.ui.searchFlag = true
    }
    // 디테일 페이지에서 삭제, 추가 등 이벤트 발생 후 그리드 페이지 진입할 때
    if (this.$store.state.ui.searchFlag) {
      this.$store.state.ui.searchFlag = false
      this.btnSearch(true)
    }
  },
  methods: {
    handleDateChange(val) {
      if (val) {
        this.searchStartDate = val
      }
      this.btnSearch(true)
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  조회
    //------------------------------------------
    btnSearch(isNotify) {
      this.gridInit(this.GetDataGrid(this.dxDataGridRef))
      this.openLoading('searching')
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeYear: this.searchStartDate
      }
      getSafetyManagerManageMaster(params, isNotify)
        .then(response => {
          if (response.success) {
            this.datagrid = response.list
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //  추가
    //------------------------------------------
    btnAdd() {
      this.openLoading('searching')
      getOrgnOrder(
        {
          clntId: this.getClntId(),
          compId: this.getCompId()
        },
        true
      )
        .then(response => {
          if (response.data) {
            const toRouter = {
              name: 'SafetyManagerManageDetail',
              params: {
                data: {
                  clntId: this.getClntId(),
                  compId: this.getCompId(),
                  orgnOrder: response.data,
                  //권한별 if 조건 : 권한 보내줌
                  grpAuthCd: this.getAuthCd(),
                  __created__: true
                }
              }
            }
            this.$router.push(toRouter)
          } else {
            this.vToastifyPrompt(
              this.$t('확정된 위험성평가 조직도가 없습니다. 위험성평가 조직도 관리 페이지로 이동하시겠습니까?'),
              'info',
              current => {
                this.$router.push('/RiskOrgnManage')
              },
              null,
              true
            )
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //  삭제
    //------------------------------------------
    async btnDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warning')
        return
      }

      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()

          this.openLoading('deleting')
          //삭제 api
          deleteSafetyManagerManage(selectedRows, true)
            .then(res => {
              this.btnSearch(true)
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    btnPopup() {
      this.popupVisible = true
    },
    popupClose() {
      this.popupVisible = false
    },
    btnDetail(cellInfo) {
      //권한별 if 조건 : 권한 보내줌
      cellInfo.data.grpAuthCd = this.getAuthCd()
      const toRouter = {
        name: 'SafetyManagerManageDetail',
        params: {
          data: cellInfo.data
        }
      }
      this.$router.push(toRouter)
    }
  }
}
</script>

<style lang="scss"></style>
